export const quotaEndPoint = 'quota';